var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.title)?_c('h2',_vm._b({staticClass:"base-title base-title__title"},'h2',_vm.$attrs,false),[_vm._t("default")],2):_c('p',_vm._b({staticClass:"base-title base-title__desciption"},'p',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }